import React, { useMemo } from 'react'
import { AvatarRound, BtnV2, l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import {
  AiAutomationToneOfVoiceActions,
  AiAutomationToneOfVoiceSelectors,
} from 'apps/aiAutomation/store/toneOfVoice'
import { getInstagramChannel } from 'common/core/selectors/channelSelectors'
import { AiAutomationTovState } from 'shared/api/requests/aiToneOfVoice/schemas'

import cm from './styles.module.css'

export const EmptyState = () => {
  const dispatch = useAppDispatch()

  const tovState = useAppSelector(AiAutomationToneOfVoiceSelectors.getTovState)

  const replies = useMemo(
    () => [
      l.translate('That means a lot! So glad it spoke to you 💛'),
      l.translate('Your feedback truly inspires us to keep creating!'),
    ],
    [],
  )

  const { avatar } = useAppSelector(getInstagramChannel)

  const initSetup = () => {
    if (tovState === AiAutomationTovState.NOT_STARTED) {
      AiAutomationAnalytics.logTovRateProcessStarted({
        is_first_generation: true,
      })
    }
    dispatch(AiAutomationToneOfVoiceActions.initializeFx())
    dispatch(AiAutomationLayoutActions.viewOpened({ view: SidebarViewType.TOV_SETUP }))
  }

  return (
    <div className="m-t-xl">
      <h4 className="m-b text-subheading">{l.translate('Set AI’s tone ')}</h4>

      <div className={cm.preview}>
        <ul className={cm.replies}>
          {replies.map((reply, index) => (
            <li className={cm.reply} key={index}>
              <AvatarRound src={avatar} size="xsmall" />

              <p className="m-0">{reply}</p>
            </li>
          ))}
        </ul>

        <p>
          {l.translate(
            'AI captures your tone from Instagram comments and drafts replies you can tweak to match your voice',
          )}
        </p>

        <BtnV2 onClick={initSetup} className="m-t-md" variant="primary" fullWidth>
          {l.translate('Set AI’s tone')}
        </BtnV2>
      </div>
    </div>
  )
}
